import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useApp } from "@/contexts/AppContext";
import { formatSAR } from "@/lib/i18n";

export default function ProductCard({ product }) {
  const { t, lang } = useApp();
  const name = lang === "ar" ? product.name_ar : product.name_en;
  const category = lang === "ar" ? product.category_ar : product.category_en;
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;
  const styleCount = (product.variants || []).length;

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-surface border border-border rounded-xl overflow-hidden shadow-ambient hover:shadow-floating transition-all duration-300 hover:-translate-y-0.5"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-muted">
        <img
          src={product.preview_image}
          alt={name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 start-3 bg-surface/90 backdrop-blur-sm text-[10px] font-bold uppercase tracking-widest text-muted-foreground px-2.5 py-1 rounded-full border border-border">
          {category}
        </div>
        {styleCount > 1 && (
          <div className="absolute bottom-3 start-3 bg-[#FFD60A] text-black text-[10px] font-bold px-2 py-1 rounded-md shadow-sm">
            {styleCount} {lang === "ar" ? "نمط" : "styles"}
          </div>
        )}
      </div>
      <div className="p-4 flex flex-col gap-2">
        <h3 className="font-semibold text-base line-clamp-1" title={name}>
          {name}
        </h3>
        <p className="text-xs text-muted-foreground line-clamp-2 min-h-[2rem]">
          {lang === "ar" ? product.description_ar : product.description_en}
        </p>
        <div className="flex items-center justify-between mt-1">
          <div>
            <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
              {lang === "ar" ? "من" : "from"}
            </span>
            <p className="text-primary font-bold text-lg leading-tight" data-testid={`product-price-${product.id}`}>
              {formatSAR(product.base_price, lang)}
            </p>
          </div>
          <Button
            size="sm"
            data-testid={`view-product-${product.id}`}
            className="gap-1 rounded-full"
          >
            {t.viewProduct}
            <Arrow className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
    </Link>
  );
}
